function t(r){return typeof r=="string"}export{t as a};
